var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCsvFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.446 22.154L12.49 0H.667v20.227l13.78 1.927z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.362 20.227V6.742l-4.816-1.926L17.62 0h-5.13l.03 22.154 11.842-1.927z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.62 6.742V0l6.742 6.742h-6.743z",
    fill: "#ECECEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.42 19.692H.668V32H24.42V19.692z",
    fill: "#3F6600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.22 24.232l-.727.861c-.324-.395-.804-.642-1.242-.642-.784 0-1.377.621-1.377 1.433 0 .826.593 1.454 1.377 1.454.417 0 .897-.226 1.242-.579l.735.777c-.53.543-1.313.903-2.04.903-1.49 0-2.598-1.094-2.598-2.541 0-1.426 1.136-2.499 2.64-2.499a2.87 2.87 0 011.99.833zM14.824 23.935l-.473.981c-.522-.303-1.179-.515-1.581-.515-.325 0-.544.12-.544.36 0 .854 2.612.367 2.612 2.153 0 .988-.875 1.51-1.976 1.51-.826 0-1.673-.31-2.26-.79l.488-.967c.508.445 1.27.741 1.786.741.395 0 .642-.148.642-.43 0-.876-2.612-.353-2.612-2.104 0-.91.784-1.49 1.97-1.49.713 0 1.44.22 1.948.551zM17.119 28.383l-1.92-4.942h1.341l1.264 3.636 1.263-3.636h1.292l-1.941 4.942h-1.3z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/csv-file.c38f0ffde04ccd9ca26a882a3e1b42cc.svg";
export { SvgCsvFile as ReactComponent };